<template>
  <div class="apiContent">
    <img src="@/assets/images/Home/api-6.png">
    <img src="@/assets/images/Home/api-5.png">
    <img src="@/assets/images/Home/api-5.png">
    <div class="page" ref="page">
      <div class="title">
        <div class="circle"></div>
        <div class="lock">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          <div></div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={8} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </div>
      <div class="view">
        <div class="currency" ref="currency">
          <span>USD $ 2000.00</span>
          <div></div>
        </div>
        <ul class="info" ref="info">
          <li>
            <p>{{ $t('components.apiAnimation.paymentMethod') }}</p>
          </li>
          <li>
            <span>{{ $t('components.apiAnimation.cardNumber') }}</span>
            <p>4014 0034 0909 1002</p>
            <img src="@/assets/images/Home/bankCard.png">
          </li>
          <li>
            <span>CVV</span>
            <p>123</p>
          </li>
          <li>
            <span>{{ $t('components.apiAnimation.expiryDate') }}</span>
            <p>06/16</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="idea" ref="idea">
      <!-- <img src="@/assets/images/logo-footer.png">
      <div class="line"></div> -->
      <div class="info">
        <ul>
          <li v-for="(item ,index) in rows" :key="index">{{item}}</li>
        </ul>

        <div class="typing">
          <span class="typingText" ref="typingText"></span>
          <i class="caret"></i>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import base from '../base'
  import tween from '@tweenjs/tween.js'
  export default {
    extends: base,
    name: "index",
    data() {
      return {
        index: -1,
        count: 0,
        total: 0,
        row: 0,
        rows : ['1','~','~','~','~','~','~'],
        codes: [
          {
            str: 'const',
            color: '#0784FF',
          },
          {
            str: ' client =',
          },
          {
            str: ' require',
            color: '#F5A623',
          },
          {
            str: '('
          },
          {
            str: '`module`',
            color: '#FCA856'
          },
          {
            str: ');'
          },
          {
            wrap: true,
            str: 'await',
            color: '#0784FF',
          },
          {
            str: ' client.paymentIntents.',
          },
          {
            str: 'create',
            color: '#FCA856'
          },
          {
            str: '({',
          },
          {
            wrap: true,
            str: '  amount: ',
          },
          {
            str: '2000',
            color: '#F8E71C',
          },
          {
            str: ',',
          },
          {
            wrap: true,
            str: '  cuttency:',
          },
          {
            str: "'USD'",
            color: '#74e4a2',
          },
          {
            str: ',',
          },
          {
            wrap: true,
            str: '  card:',
          },
          {
            str: "'4014003409091002'",
            color: '#74e4a2',
          },
          {
            str: ',',
          },
          {
            wrap: true,
            str: '});',
          },
          // {
          //   wrap: true,
          //   str: 'await',
          //   color: '#0784FF',
          // },
          // {
          //   str: ' gogotranx.paymentinfo.',
          // },
          // {
          //   str: 'create',
          //   color: '#FCA856'
          // },
          // {
          //   str: '({',
          // },
        ],
        isPlaying : false,
      }
    },
    mounted() {
    },
    methods: {
      play() {
        if(this.isPlaying) return;
        this.isPlaying = true;
        this.startTyping();
      },
      startTyping () {
        this.index += 1;
        if (this.index >= this.codes.length) {
          this.setTimeOut(() => {
            this.setTimeOut(() => {
              this.$refs.currency.style.marginLeft = 0;
              this.$refs.currency.style.opacity = 1;

                this.$refs.info.style.opacity = 1;
                for(let i = 0 ; i < this.$refs.info.childNodes.length; i++){
                  this.setTimeOut(() => {
                    this.$refs.info.childNodes[i].style.marginLeft = 0;
                    this.$refs.info.childNodes[i].style.opacity = 1;
                  },50*i);
                }

            },500);

            this.moveFun(this.$refs.idea,{left:34,top:110},{left:220,top:-9},{left:113,top:-30});
            this.moveFun(this.$refs.page,{left:113,top:-128},{left:-113,top:-9},{left:-45,top:110},10);
          },800);
          return;
        }

        let str = this.codes[this.index].str.split('');
        let color = this.codes[this.index].color || '#FFF';

        this.$refs.typingText.innerHTML += (this.codes[this.index].wrap ? '<br>' : '') + '<span style=" display: inline-block ; color: ' + color + '">';

        let node = this.$refs.typingText.childNodes[this.$refs.typingText.childNodes.length - 1];
        this.count = -1;
        this.total = str.length;
        for (let j = 0; j < str.length; j++) {
          this.setTimeOut(() => {
            if (!this.$refs.typingText) return;
            this.count += 1;
            node.innerHTML += str[this.count];
            if (this.count + 1 == this.total) {
              this.startTyping();
            }
          }, 40 * (j + 1));
        }

        if (this.codes[this.index].wrap) {
          this.row += 1;
          this.rows.splice(this.row, 1, this.row + 1);
        }
      },

      moveFun (target,pos1,pos2,pos3,zIndex) {
        new tween.Tween({ left: pos1.left }).to({ left: pos2.left }, 300).onUpdate(t => {
          target.style.left = t.left + 'px';
        }).start();

        new tween.Tween({ top: pos1.top }).to({ top: pos2.top }, 300).easing(tween.Easing.Cubic.In).onUpdate(t => {
          target.style.top = t.top + 'px';
        }).start();

        this.setTimeOut(() => {
          if(zIndex)
            target.style.zIndex = zIndex;
          new tween.Tween({ left: pos2.left }).to({ left: pos3.left }, 300).easing(tween.Easing.Cubic.In).onUpdate(t => {
            target.style.left = t.left + 'px';
          }).start()
          new tween.Tween({ top: pos2.top }).to({ top: pos3.top }, 300).onUpdate(t => {
            target.style.top = t.top + 'px';
          }).start()
        },300);
      },
    }
  }
</script>

<style lang="less" scoped>
  .apiContent {
    position: relative;
    user-select: none;
    & > img {
      width: 366px;
      &:nth-child(2) {
        position: absolute;
        top: 16px;
        left: 46px;
        width: 59px;
      }
      &:nth-child(3) {
        position: absolute;
        bottom: -25px;
        left: 265px;
        width: 59px;
        transform: scale(-1);
      }
    }

    .page {
      position: absolute;
      background: #FFFFFF;
      width: 304px;
      height: 362px;
      border-radius: 16px;
      left: 113px;
      top: -128px;
      overflow: hidden;

      box-shadow: 0px 20px 20px -5px rgba(0, 0, 0, 0.2);

      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 16px;
        background: #DADFE5;
        border-radius: 16px 16px 0px 0px;

        .circle {
          width: 12px;
          height: 12px;
          border-radius: 8px;
          border: 3px solid #9DA7B1;
          margin-right: 15px;
        }
        .lock {
          display: flex;
          align-items: center;
          width: 213px;
          background: #CED6DD;
          border-radius: 7px;
          padding: 4px 7px;
          margin-right: 12px;
          & > svg {
            width: 20px;
          }
          & > div {
            width: 133px;
            height: 8px;
            background: #7A8490;
            border-radius: 6px;
            margin-left: 10px;
          }
        }

        & > svg {
          width: 20px;
        }
      }

      .view {
        padding: 29px 22px 0 22px;

        .currency {
          display: flex;
          justify-content: space-between;
          margin-bottom: 24px;
          transition: all 0.5s cubic-bezier(0,1,.37,1.1);
          width: 260px;
          margin-left: -260px;
          opacity: 0;
          & > span {
            font-size: 14px;
            font-weight: bold;
            color: #082440;
            line-height: 20px;
          }
          & > div {
            width: 77px;
            height: 26px;
            background: #F6F6F6;
            border-radius: 13px;
          }
        }

        .info {
          padding: 15px 20px;
          border-radius: 8px;
          border: 1px solid #F4F4F5;
          transition: all 1s;
          overflow: hidden;
          opacity: 0;

          & > li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            padding: 8px;
            background: #FAFDFF;
            border-radius: 6px;
            border: 1px solid #E5F2FF;
            margin-bottom: 32px;

            transition: all 0.5s cubic-bezier(0,1,.37,1.1);
            opacity: 0;
            margin-left: -260px;

            & > span {
              position: absolute;
              top: -18px;
              font-size: 10px;
              font-weight: 400;
              color: #092641;
              line-height: 15px;
            }
            & > p {
              font-size: 10px;
              font-weight: 400;
              color: #092641;
              line-height: 15px;
            }
            & > img {
              width: 28px;
            }

            &:first-child {
              justify-content: center;
              background: #EDF6FF;
              border-color: #0781FA;
              & > p {
                text-align: center;
                color: #0781FA;
              }
            }
          }
        }
      }
    }

    .idea {
      position: absolute;
      left: -20px;
      top: 105px;
      width: 298px;
      height: 243px;
      background: #1A1D21;
      box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.15);
      border-radius: 16px;

      & > img {
        width: 134px;
        margin: 18px;
      }
      .line {
        opacity: 0.6;
        border: #FFFFFF dashed 1px;
      }
      .info {
        display: flex;
        & > ul {
          padding: 9px 10px 0 10px;
          &:last-child {
            padding: 9px 0;
          }
          & > li {
            font-size: 10px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 24px;
          }
        }

        .typing {
          padding: 7px 0;
          overflow: hidden;
          & > span {
            font-size: 10px;
            color: #FFFFFF;
            line-height: 25px;
            letter-spacing: 1px;
            word-break: break-all;
            white-space:pre;
          }
          .caret {
            &:after {
              content: "";
              display: inline-block;
              width: 2px;
              height: 11px;
              margin-bottom: -2px;
              margin-left: 2px;
              background-color: #FFF;
              animation: twinkling 1s step-end infinite;
            }
          }
        }

        @-webkit-keyframes twinkling{
          0%, 100%{
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
        }
        @keyframes twinkling{
          0%, 100%{
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
        }
      }
    }
  }
</style>
